import {useSnackbar} from "../contexts/SnackbarContext";
import {useEffect, useState} from "react";
import {DataSource} from "../models/models";
import {collectionService} from "../services/collection.service";
import {parseError} from "../errors/http.service";


interface UseDataSourcesType {
    dataSources: DataSource[];
    isLoadingDataSources: boolean;
    refetchDataSources: () => Promise<void>;
}

// TODO: infinite scroll or pagination
export const useDataSources = (): UseDataSourcesType => {
    const {showSnackbar} = useSnackbar();

    const [dataSources, setDataSources] = useState<DataSource[]>([]);
    const [isLoadingDataSources, setIsLoadingDataSources] = useState<boolean>(true);

    const fetchDataSources = async () => {
        try {
            setIsLoadingDataSources(true);
            const data = await collectionService.fetchCollections(0, 1000);
            setDataSources(data?.content ?? []);
        } catch (error) {
            showSnackbar(parseError(error), 'error');
        } finally {
            setIsLoadingDataSources(false);
        }
    };

    useEffect(() => {
        void fetchDataSources();
    }, []);

    return {
        dataSources,
        isLoadingDataSources,
        refetchDataSources: fetchDataSources,
    };
};

export default useDataSources;